import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { OfbizFormsService } from './ofbiz-forms.service';

@Component({
  selector: 'ubs-ofbiz-add-dialog',
  templateUrl: './ofbiz-add-dialog.component.html',
  styleUrls: ['./ofbiz-add-dialog.component.scss']
})
export class OfbizAddDialogComponent implements OnInit {
  @Input() title: string;
  @Input() data: any;
  selectedValue: any;
  options: any;
  fields: any[];
  form: FormGroup;
  formFields: any[];

  constructor(protected ref: NbDialogRef<OfbizAddDialogComponent>,
    private ofbizFormService: OfbizFormsService) { }

  ngOnInit(): void {
    this.options = this.data["options"];
    this.selectedValue = this.data["selectedValue"];
    this.ofbizFormService.getForm(this.data["options"])
      .subscribe(data => {
        this.fields = data["fields"];
        this.ofbizFormService.getFormFields(this.fields)
          .subscribe((formFields) => {
            const keys = Object.keys(this.selectedValue);
            if (formFields) {
              keys.forEach(key => {
                const field = formFields.find(field => field.name == key);
                if (field) {
                  field["value"] = this.selectedValue[key];
                }
              });
              this.formFields = formFields;
              this.form = this.ofbizFormService.toFormGroup(this.formFields);
            }
          })
      })
  }

  onSubmit() {
    console.log(this.form.value);
  }

  dismiss() {
    this.ref.close();
  }

}
